<div class="p-a-xl">
    <app-calendar-view [actions]="actions" />
</div>
